




























import { Component, Vue } from "vue-property-decorator";
@Component
export default class success extends Vue {
  enterpriseName: any = "";
  reserveTime: any = "";
  created() {
    console.log(this.$route.query.enterpriseName);
    this.enterpriseName = this.$route.query.enterpriseName;
    this.reserveTime = this.$route.query.reserveTime;
    setTimeout(() => {
      this.$router.push({
        name: "Home",
      });
      sessionStorage.removeItem("pinpai");
    }, 3000);
  }
}
